"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4124],{

/***/ 8966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ButtonChevron; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50983);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTransform = (props) => {
  let style = "";
  switch (props.direction) {
    case "right":
      style = "transform: rotate(90deg)";
      break;
    case "down":
      style = "transform: rotate(180deg)";
      break;
    case "left":
      style = "transform: rotate(-90deg)";
      break;
  }
  return style;
};
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  display: flex;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
  var _b = _a, {
    children,
    direction
  } = _b, props = __objRest(_b, [
    "children",
    "direction"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    direction,
    name: "chevron-up",
    size: 12
  }));
};




/***/ }),

/***/ 29283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55271);
/* harmony import */ var _ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8966);
/* harmony import */ var _Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29556);
/* harmony import */ var _Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37753);
/* harmony import */ var _Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32762);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.li */ .z.li(({ selected, theme }) => `
    padding: 0.6rem 0.8rem;
    font-size: 14px;
    background-color: ${selected ? "#f7f7f7" : ""};
    color: ${selected ? theme.brand.primary : "inherit"};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #f7f7f7;
      color: ${theme.brand.primary};
      cursor: pointer;
    }
  `);
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span`
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 0.25rem;
  text-align: left;
`;
const Content = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.ul */ .z.ul`
  border-radius: 0.25rem;
  border: 1px solid #e0e0e0;
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  box-shadow: 2px 2px 0.8rem 0 rgba(0, 0, 0, 0.08);
  overflow-y: auto;
`;
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
    width: 100%;
`);
const StyledButtonChevron = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonChevron */ .y)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
  border-color: #e0e0e0;
`;
const StyledDropdown = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L)`
  width: 100%;
  button {
    ${(p) => p.disabled ? `
      background-color: #f8f8fc;
      cursor: not-allowed;` : ""}
    > span:first-child {
      flex: 1;
      text-align: left;
    }
  }
`;
const sameWidthModifier = {
  name: "sameWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
  }
};
const dropdownConfigs = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }
  ]
};
const Select = (_a) => {
  var _b = _a, {
    title,
    onChange,
    items,
    selectedValue = null,
    variant,
    sameWidth = true,
    disabled = false
  } = _b, props = __objRest(_b, [
    "title",
    "onChange",
    "items",
    "selectedValue",
    "variant",
    "sameWidth",
    "disabled"
  ]);
  const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleChange = ({ value }) => () => {
    setDropdownOpen(false);
    onChange(value);
  };
  const toggle = () => !disabled && setDropdownOpen((prevState) => !prevState);
  const currentTitle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (selectedValue === null) {
      return title;
    }
    const filteredItems = items.filter(({ value }) => value === selectedValue);
    return filteredItems.length > 0 ? filteredItems[0].content : title;
  }, [items, selectedValue, title]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDropdown, {
    isOpen: dropdownOpen,
    disabled,
    toggle
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_5__/* .DropdownToggle */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonChevron, {
    type: "button",
    direction: dropdownOpen ? "up" : "down",
    variant: variant === "invalid" ? "danger" : void 0,
    outline: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, currentTitle))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_6__/* .DropdownMenu */ .h, {
    popperConfig: __spreadProps(__spreadValues({}, dropdownConfigs), {
      modifiers: [
        ...dropdownConfigs.modifiers,
        sameWidth && sameWidthModifier
      ]
    })
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, items.map(({ content, value }, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListItem, {
    onClick: handleChange({ content, value }),
    selected: value === selectedValue,
    key: index
  }, content))))));
};




/***/ }),

/***/ 45000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46183);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55257);





const Backdrop = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  sm: "400px",
  md: "700px",
  lg: "960px"
};
const ModalContent = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme, size, maxHeight, borderRadius }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${sizeMaps[size]};
  border-radius: ${borderRadius ? borderRadius : theme.borderRadius};
  max-height: ${maxHeight ? maxHeight : `90%`};
  z-index: 1060;
  position: relative;
  overflow-y: auto;
`);
const Modal = ({
  show,
  onHide,
  children,
  className,
  size = "md",
  maxHeight,
  borderRadius
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof document !== "undefined") {
      if (show) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${(0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .getScrollbarWidth */ .np)()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Backdrop, {
    onClick: onHide
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalContent, {
    className,
    size,
    borderRadius,
    maxHeight
  }, children));
};




/***/ }),

/***/ 76609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;




/***/ }),

/***/ 88155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  text-align: center;
  .title {
    margin-bottom: 0;
  }
`;
const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h5", {
  className: "title"
}, children));




/***/ }),

/***/ 46183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "Nq": function() { return /* binding */ canUseDOM; },
/* harmony export */   "TH": function() { return /* binding */ getMoneyValueUnit; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; }
/* harmony export */ });
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    window.scrollbarWidth = width;
  }
  return width;
};
const getMoneyValueUnit = (value) => {
  if (value < 1e6)
    return { value: Math.round(value / 1e3 * 1e3) / 1e3, unit: "K" };
  if (value > 1e9)
    return {
      value: Math.round(value / 1e9 * 1e3) / 1e3,
      unit: "t\u1EF7"
    };
  return { value: Math.round(value / 1e6 * 1e3) / 1e3, unit: "tr" };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
  let result = imageUrl;
  if (imageUrl.includes("googleusercontent.com")) {
    if (imageWidth) {
      result = `${imageUrl}=w${imageWidth}`;
    }
  }
  return result;
};




/***/ }),

/***/ 34124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PopupRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45000);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88155);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76609);
/* harmony import */ var components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17838);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21598);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10232);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24122);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-bottom: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








const PopupRegionPicker = (param)=>{
    let { showPopup , selected , setSelected , terminals , locationOptions , onClosePopup , onSubmitNewLocation , activeLocation , title , useDropdownPicker  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, {
            size: "sm",
            show: showPopup,
            onHide: ()=>onClosePopup(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .ModalHeader */ .x, {
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Chọn khu vực giao h\xe0ng")
                }),
                !!activeLocation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIcon, {
                    onClick: ()=>onClosePopup(),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CloseOutlined */ .X, {
                        size: 32,
                        color: "#000000"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .ModalBody */ .f, {
                    children: useDropdownPicker ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    textAlign: "justify"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgWrapper, {
                                src: "/umbala/location.svg",
                                alt: "choose location"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_7__.DropDownRegionPicker, {
                                terminals: terminals,
                                onSelectTerminal: setSelected
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                variant: "primary",
                                size: "m",
                                block: true,
                                onClick: ()=>onSubmitNewLocation(),
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("X\xe1c nhận")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPicker, {
                        options: locationOptions,
                        value: selected,
                        onChange: setSelected,
                        onSubmit: ()=>{
                            onSubmitNewLocation();
                        },
                        title: title
                    })
                })
            ]
        })
    });
};
const StyledPicker = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .RegionPicker */ .H)(_templateObject());
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .Z.div(_templateObject1());
const ImgWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].img */ .Z.img(_templateObject2());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z)(_templateObject3());
const CloseIcon = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .Z.div(_templateObject4());


/***/ }),

/***/ 17838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DropDownRegionPicker": function() { return /* binding */ DropDownRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29283);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86324);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const StyledSelect = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Select */ .P)(_templateObject());
const DropDownRegionPicker = (param)=>{
    let { terminals , onSelectTerminal  } = param;
    const { 0: provinces , 1: setProvinces  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: districts , 1: setDistricts  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: wards , 1: setWards  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: provinceCode , 1: setProvinceCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: districtCode , 1: setDistrictCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: wardCode , 1: setWardCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const availCodes = {
        wards: new Set(),
        districts: new Set(),
        provinces: new Set()
    };
    for (const terminal of terminals){
        availCodes.wards.add(terminal.location.ward);
        availCodes.districts.add(terminal.location.district);
        availCodes.provinces.add(terminal.location.province);
    }
    const { locationService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get all provinces;
        locationService.getProvinces().then((allProvinces)=>{
            const allowedProvinces = allProvinces.filter((province)=>availCodes.provinces.has(province.code)).map((province)=>({
                    content: province.name,
                    value: province.code
                }));
            setProvinces(allowedProvinces);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get list of district when province changes
        if (provinceCode) locationService.getDistrictsByProvinceCode(provinceCode).then((allDistricts)=>{
            const allowedDistricts = allDistricts.filter((district)=>availCodes.districts.has(district.code)).map((district)=>({
                    content: district.name,
                    value: district.code
                }));
            setDistricts(allowedDistricts);
            setWards([]);
        });
    }, [
        provinceCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get list of wards
        if (districtCode) locationService.getWardsByDistrictCode(districtCode).then((allWards)=>{
            const allowedWards = allWards.filter((ward)=>availCodes.wards.has(ward.code)).map((ward)=>({
                    content: ward.name,
                    value: ward.code
                }));
            setWards(allowedWards);
        });
    }, [
        districtCode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn tỉnh/th\xe0nh phố"),
                selectedValue: provinceCode,
                onChange: (code)=>{
                    if (code !== provinceCode) {
                        setProvinceCode(code);
                        setDistrictCode("");
                        setWardCode("");
                    }
                },
                items: provinces
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn quận/huyện"),
                selectedValue: districtCode,
                onChange: (code)=>{
                    if (code !== districtCode) {
                        setDistrictCode(code);
                        setWardCode("");
                    }
                },
                items: districts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn phường/x\xe3"),
                selectedValue: wardCode,
                onChange: (code)=>{
                    setWardCode(code);
                    // use index is weird, change later
                    if (onSelectTerminal) onSelectTerminal(terminals.findIndex((terminal)=>terminal.location.ward === code));
                },
                items: wards
            })
        ]
    });
};


/***/ })

}]);